import reducers from './reducers'

export { default as authTypes } from './types'
export { default as authActions } from './actions'
export { default as authSelectors } from './selectors'

export default reducers
